import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useWhTaskFiltersStore } from 'shared/stores/use-wh-task-filters';
import { WhTaskFiltersDrawer } from 'components/wh-tasks/wh-task-filter/components/wh-task-filters-drawer';
import { WhTaskSearch } from 'components/wh-tasks/wh-task-filter/components/wh-task-search';

export const WhTaskFilter: React.FC = () => {
  const { filters, search } = useWhTaskFiltersStore();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Space size='small'>
        <WhTaskSearch />
        <Badge dot={!!filters}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Space>
      <WhTaskFiltersDrawer form={form} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
